import script from "./WalletButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletButton.vue?vue&type=script&setup=true&lang=ts"

import "./WalletButton.vue?vue&type=style&index=0&id=2d6eb765&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d6eb765"]])

export default __exports__